// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* media=\"screen and (min-width: 575px)\" */\n@media screen and (min-width: 575px) {\n}", "",{"version":3,"sources":["webpack://./src/assets/css/styles/styles-sm.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;AACA","sourcesContent":["/* media=\"screen and (min-width: 575px)\" */\n@media screen and (min-width: 575px) {\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
